import { render } from "./viewInfo.vue?vue&type=template&id=f345fc84&scoped=true"
import script from "./viewInfo.vue?vue&type=script&lang=js"
export * from "./viewInfo.vue?vue&type=script&lang=js"

import "./viewInfo.vue?vue&type=style&index=0&id=f345fc84&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f345fc84"]])

export default __exports__